<template>
  <div class="admin-layout">
    <AdminHeader />
    <div class="admin-body">
      <AdminSidebar />
      <main class="admin-page-content">
        <router-view />
      </main>
    </div>
  </div>
</template>

<script>
import AdminHeader from '@/components/admin/AdminHeader.vue'
import AdminSidebar from '@/components/admin/AdminSidebar.vue'

const routeTitles = {
  crawlconfig: '采集配置',
  import: 'openFDA 批量导入',
}

export default {
  name: 'AdminLayout',
  components: { AdminHeader, AdminSidebar },
  watch: {
    '$route.path': {
      immediate: true,
      handler(path) {
        const segment = path.split('/')[2] || 'crawlconfig'
        const title = routeTitles[segment] || '管理后台'
        document.title = `PharmAID 管理后台 · ${title}`
      },
    },
  },
  beforeUnmount() {
    document.title = 'PharmAID'
  },
}
</script>

<style>
@import '@/styles/admin.css';
@import '@/styles/admin-shell.css';
</style>
